import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const copyResourceKind = z.enum([
  "flow",
  "emailTemplate",
  "savedSection",
]);
export type CopyResourceKind = z.infer<typeof copyResourceKind>;

export const copyResourceAction = z.enum(["created", "skippedExisting"]);
export type CopyResourceAction = z.infer<typeof copyResourceAction>;

export const copyResourceItem = z.object({
  kind: copyResourceKind,
  name: z.string(),
  action: copyResourceAction,
  sourceId: z.string(),
  /** Trigger keys, for flows. */
  detail: z.string().optional(),
});
export type CopyResourceItem = z.infer<typeof copyResourceItem>;

export const copyReturnTrackingConfiguration = unaryRpc({
  name: "copyReturnTrackingConfiguration",
  input: z.object({
    sourceTeamId: zExt.objectId(),
    destinationTeamId: zExt.objectId(),
    dryRun: z.boolean(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string(),
    sourceTeamName: z.string(),
    destinationTeamName: z.string(),
    dryRun: z.boolean(),
    items: z.array(copyResourceItem),
    warnings: z.array(z.string()),
  }),
});
